<template>
	<el-card :body-style="{ padding: 0 }">
		<!-- Fixed header -->
		<div slot="header" class="header">
			<img src="../../patient/card/image/questionnaire.png" style="margin-left:2px">
			<span><strong>Upload Questionnaires</strong></span>
		</div>

		<div class="body" v-if="uploading">
			<Loading :text="uploading ? 'Uploading images...' : 'Processing rows...'" background="#f0f0f0"></Loading>
		</div>

		<!-- Show the three steps for importing in sequence -->
		<div class="body" v-else>

		</div>
	</el-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/module/component/Loading'

export default {
	name: 'questionnaire-upload-card',

	data() {
		return {
			uploading: false
		}
	},

	components: {
		Loading
	}
}
</script>

<style lang="scss" scoped>
@import "../../patient/card/style.scss";
@import "@/module/app/theme/color.scss";


.body {
    background: lighten($questionnaire-color, 60%);
    padding: 10px 15px;
}
</style>
